import {
  Component,
  OnInit,
  Inject,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ENTER, COMMA } from "@angular/cdk/keycodes";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { MatChipInputEvent } from "@angular/material/chips";
import { BaseDialog } from "src/app/base-dialog";
import { RelatorioService } from "../../services/relatorio.services";
import { AuthService } from "src/app/services/ajs-auth.service";

@Component({
  selector: "mandae-relatorio-automatizado-editar",
  templateUrl: "./editar-relatorio.component.html",
  styleUrls: ["./editar-relatorio.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalEditarComponent extends BaseDialog<ModalEditarComponent>
  implements OnInit {
  public isLoaded = false;

  public currentCliente: any = [];

  public contas_vinculadas: any = [];

  public formulario: FormGroup;

  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  public emails = [];

  public selectable = true;

  public removable = true;

  public addOnBlur = true;

  public periodicidadeEnvio = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data,
    dialogRef: MatDialogRef<ModalEditarComponent>,
    public relatorioService: RelatorioService,
    public authService: AuthService,
    public cr: ChangeDetectorRef
  ) {
    super(dialogRef);

    this.formulario = new FormGroup({
      nome: new FormControl(null, Validators.required),
      contas: new FormControl(),
      email: new FormControl(null, Validators.email),
      periodicidade: new FormControl(Validators.required),
      situacao: new FormControl("", Validators.required),
      periodicidadeEnvio: new FormControl(),
      mensal: new FormControl(),
      semanal: new FormControl()
    });
  }

  public ngOnInit() {
    this.verificaContaPai();
    console.log(this.data);
  }

  public async verificaContaPai() {
    try {
      const data = await this.relatorioService.consultaClientePrincipal(
        this.authService.getCurrentUser()
          ? this.authService.getCurrentUser().id
          : 0
      );

      this.currentCliente = data;

      if (data.contas_vinculadas.length) {
        this.formulario.get("contas").setValidators(Validators.required);
      } else {
        this.formulario.get("contas").setValue(this.currentCliente.email);
      }

      this.preencherFormulario();

      this.isLoaded = true;
    } catch (error) {}
  }

  public preencherFormulario() {
    this.contas_vinculadas = this.data.contas.split(",");
    this.formulario.get("nome").setValue(this.data.nome);
    this.formulario.get("contas").setValue(this.data.contas.split(","));
    this.formulario.get("periodicidade").setValue(this.data.periodo);
    if (this.data.situacao !== null) {
      this.formulario.get("situacao").setValue(this.data.situacao);
    }
    this.formulario.get("periodicidadeEnvio").setValue("semanal");
    this.formulario.get("semanal").setValue(this.data.agenda[0].semana);
    this.periodicidadeEnvio = "semanal";

    if (this.data.agenda[0].dia) {
      this.formulario.get("periodicidadeEnvio").setValue("mensal");
      this.formulario.get("mensal").setValue(this.data.agenda[0].dia);
      this.periodicidadeEnvio = "mensal";
    }

    if (this.data.agenda.length === 7) {
      this.formulario.get("periodicidadeEnvio").setValue("diario");
      this.periodicidadeEnvio = "diario";
    }

    this.cr.markForCheck();
    this.prepareEmailsEnvio();
  }

  public prepareEmailsEnvio() {
    const emails = this.data.emailEnvio.split(";");

    const lista = [];

    for (let i = 0; i < emails.length; i++) {
      const email = {
        name: emails[i]
      };

      lista.push(email);
    }

    this.emails = lista;
  }

  public adicionarEmail(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    const valid = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(value);

    if (valid) {
      if ((value || "").trim()) {
        this.emails.push({ name: value.trim() });
      }

      if (input) {
        input.value = "";
      }
    }
  }

  public removerEmail(email: any): void {
    const index = this.emails.indexOf(email);

    if (index >= 0) {
      this.emails.splice(index, 1);
    }
  }

  public handleChangePeriodicidadeEnvio(event: any) {
    this.periodicidadeEnvio = event.target.value;
  }

  public async editarRelatorio() {
    try {
      const agendaDia = {
        dia: this.formulario.value.mensal
      };

      const agendaSemanal = {
        semana: this.formulario.value.semanal
      };

      const relatorio = {
        nome: this.formulario.value.nome,
        contas: this.formulario.value.contas.toString(),
        emailEnvio: this.convertEmailsParaString(),
        periodo: this.formulario.value.periodicidade,
        situacao: this.formulario.value.situacao
          ? this.formulario.value.situacao
          : null,
        agenda: []
      };

      this.formulario.value.periodicidadeEnvio === "mensal"
        ? (relatorio.agenda[0] = agendaDia)
        : (relatorio.agenda[0] = agendaSemanal);

      if (this.formulario.value.periodicidadeEnvio === "diario") {
        relatorio.agenda = [
          {
            semana: "0"
          },
          {
            semana: "1"
          },
          {
            semana: "2"
          },
          {
            semana: "3"
          },
          {
            semana: "4"
          },
          {
            semana: "5"
          },
          {
            semana: "6"
          }
        ];
      }

      await this.relatorioService.atualizarRelatorio(this.data.id, relatorio);

      this.dialogRef.close({ status: true, message: "created" });
    } catch (error) {
      console.log("e", error);
    }
  }

  public fechar() {
    this.dialogRef.close({ status: false, message: "closed" });
  }

  private convertEmailsParaString() {
    const emails = [];

    for (let i = 0; i < this.emails.length; i++) {
      emails.push(this.emails[i].name);
    }

    return emails.join(";");
  }

  public compareContas(option1: any, option2: any): boolean {
    return option1 === option2;
  }
}
